import { joinURL, withQuery } from 'ufo'
import type { ArticleCardProps } from '../components/ArticleCard/ArticleCard.vue'
import { useSearchParams } from './data-fetching/useSearchParams'

export const useRedirectActions = () => {
  const { selectedCategory, selectedLang } = useSearchParams()
  const navigationOptions = { open: { target: '_blank' } }
  const appConfig = useAppConfig()

  function getNewsArticleUrl(item: ArticleCardProps) {
    if (!item.id) return
    const { settings } = useGlobalLayoutSettings()
    const pageUrl =
      item.type === 'video' ? settings.videoPageUrl : settings.articlePageUrl
    const path = joinURL(pageUrl, item.id)
    const query = { category: selectedCategory.value, lang: selectedLang.value }
    if (item.type == 'video') {
      return withQuery(path, query)
    }

    const siteSettingsStore = useSiteSettingsStore()
    const { data: siteSettings } = storeToRefs(siteSettingsStore)
    const { articleSummary } = useUserSettings(siteSettings)
    if (item.type !== 'video' && articleSummary.isEnabled) {
      return withQuery(path, query)
    }
    return item.articleUrl
  }

  function navigateToContentPage(
    id: string | undefined,
    category: 'article' | 'video'
  ) {
    if (!id) return
    const categorySubPath =
      category === 'article' ? appConfig.urls.article : appConfig.urls.video
    const url = joinURL('/', categorySubPath, id)
    navigateTo(withQuery(url, { lang: selectedLang.value }))
  }

  function sendToNewsPage(article: ArticleCardProps) {
    if (!article.id) return
    const navigationUrl = getNewsArticleUrl(article)
    navigateTo(navigationUrl, navigationOptions)
  }

  function navigateToHomepage(
    category = 'News',
    lang: string | string[] | undefined
  ) {
    const homePageUrl = appConfig.urls.home
    const url = withQuery(homePageUrl, { category, lang })
    navigateTo(url)
  }

  function navigateToSearchPage(query: string) {
    if (!query) return
    let url = `/search/?q=${query}`
    if (selectedLang.value) {
      url += `&lang=${selectedLang.value}`
    }
    navigateTo(url)
  }

  return {
    sendToNewsPage,
    getNewsArticleUrl,
    navigateToHomepage,
    navigateToSearchPage,
    navigateToContentPage,
  }
}
